import ViewerPage from './components/ViewerPage';

export default {
  path: '/viewer',
  component: ViewerPage,
}
